export const MY_WAITROSE_CARD_REPLACEMENT_NAME = 'MyWaitroseCardReplacement';
export const MY_WAITROSE_CARD_REPLACEMENT_SLUG = 'my-replacement-cards';
